import { render, staticRenderFns } from "./8_MultiText.vue?vue&type=template&id=682295ed&scoped=true&"
import script from "./8_MultiText.vue?vue&type=script&lang=js&"
export * from "./8_MultiText.vue?vue&type=script&lang=js&"
import style0 from "./8_MultiText.vue?vue&type=style&index=0&id=682295ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682295ed",
  null
  
)

export default component.exports